import { formatCurrency } from "@roc/ui/utils";

const usdAmount: any = params => {
  return params.value && formatCurrency(Number(params.value));
};

export enum TaskColumns {
  TASK_ID = "TASK_ID",
  LOAN_ID = "LOAN_ID",
  TITLE = "TITLE",
  DESCRIPTION = "DESCRIPTION",
  ESCALATED = "ESCALATED",
  TASK_STATUS = "TASK_STATUS",
  ASSIGNEE = "ASSIGNEE",
  TIME_ELAPSED = "TIME_ELAPSED",
  REPORTER = "REPORTER",
  PRIORITY = "PRIORITY",
  CREATED_DATE = "CREATED_DATE",
  LAST_UPDATED_DATE = "LAST_UPDATED_DATE",
  ACTIONS = "ACTIONS",

  QUEUE_START_DATE = "QUEUE_START_DATE",
  LOAN_STATUS = "LOAN_STATUS",
  LOAN_SUB_STATUS = "LOAN_SUB_STATUS",
  VALUATION_REVIEWER = "VALUATION_REVIEWER",
  PROPERTY_ADDRESS = "PROPERTY_ADDRESS",
  PROPERTY_STATE = "PROPERTY_PROPERTY_STATE",
  IV_REASON = "IV_REASON",
  TRANSACTION_TYPE = "TRANSACTION_TYPE",
  APPRAISAL_RECEIVED_DATE = "APPRAISAL_RECEIVED_DATE",
  APPRAISAL_PAID_DATE = "APPRAISAL_PAID_DATE",
  UNDERWRITING_DATE = "UNDERWRITING_DATE",
  PROPERTY_CITY = "PROPERTY_CITY",
  PROPERTY_COUNTY = "PROPERTY_COUNTY",
  UNDERWRITER = "UNDERWRITER",
  APPRAISER = "APPRAISER",
  LOAN_SUB_TYPE = "LOAN_SUB_TYPE",
  LENDER = "LENDER",
  LOAN_AMOUNT = "LOAN_AMOUNT",
  ARV = "ARV",
  APPRAISAL_REPORT_STATUS = "APPRAISAL_REPORT_STATUS",
  PROJECT_TYPE = "PROJECT_TYPE",
  CMT_REPORT_VERSION = "CMT_REPORT_VERSION"
}

export const TaskColumnsDefinitions = {
  [TaskColumns.TASK_ID]: {
    field: 'taskId',
    headerName: 'Task Id',
    maxWidth: 130,
    cellRenderer: 'taskIdUnreadMessagesCellRenderer'
  },
  [TaskColumns.LOAN_ID]: {
    field: 'loanId',
    headerName: 'Loan Id',
    cellRenderer: 'loanIdCellRenderer',
    minWidth: 100,
  },
  [TaskColumns.TITLE]: {
    field: 'title',
    headerName: 'Title',
    minWidth: 400,
    cellRenderer: 'titleCellRenderer',
  },
  [TaskColumns.DESCRIPTION]: {
    field: 'description',
    headerName: 'Description',
    minWidth: 400,
    cellRenderer: 'descriptionCellRender',
  },
  [TaskColumns.TASK_STATUS]: {
    field: 'status',
    headerName: 'Task Status',
    minWidth: 125,
    maxWidth: 125,
    cellRenderer: 'statusCellRenderer',
  },
  [TaskColumns.ESCALATED]: {
    field: 'escalated',
    headerName: 'Escalated',
    minWidth: 100,
    cellRenderer: 'escalatedCellRenderer',
  },
  [TaskColumns.ASSIGNEE]: {
    field: 'assigneeNames',
    headerName: 'Assignee',
    minWidth: 200,
    cellRenderer: 'assigneeCellRenderer',
  },
  [TaskColumns.TIME_ELAPSED]: {
    field: 'timeElapsed',
    headerName: 'Time Elapsed',
    cellRenderer: 'timeElapsedCellRenderer',
    minWidth: 100,
    maxWidth: 200,
  },
  [TaskColumns.REPORTER]: {
    field: 'ownerName',
    headerName: 'Reporter',
    minWidth: 200,
    cellRenderer: 'assigneeCellRenderer',
  },
  [TaskColumns.PRIORITY]: {
    field: 'priority',
    headerName: 'Priority',
    maxWidth: 140,
    cellRenderer: 'priorityCellRenderer',
  },
  [TaskColumns.CREATED_DATE]: {
    field: 'createdDate',
    headerName: 'Created Date',
    minWidth: 220,
    cellRenderer: 'dateCellRenderer',
  },
  [TaskColumns.LAST_UPDATED_DATE]: {
    field: 'lastUpdatedDate',
    headerName: 'Last Updated Date',
    minWidth: 220,
    cellRenderer: 'dateCellRenderer',
  },
  [TaskColumns.ACTIONS]: {
    field: 'actions',
    headerName: "Actions",
    width: 85,
    cellRenderer: 'actionCellRenderer',
    pinned: "right",
    lockPinned: true
  },

  [TaskColumns.QUEUE_START_DATE]: {
    field: 'queueStartDate',
    headerName: 'Queue Start Date',
    minWidth: 220,
    cellRenderer: 'dateCellRenderer',
  },
  [TaskColumns.LOAN_STATUS]: {
    field: 'loanStatus',
    headerName: 'Loan Status',
    minWidth: 150,
    cellRenderer: 'loanStatusCellRenderer',
  },
  [TaskColumns.LOAN_SUB_STATUS]: {
    field: 'loanSubStatus',
    headerName: 'Loan Sub Status',
    minWidth: 240,
    cellRenderer: 'loanSubStatusCellRenderer',
  },
  [TaskColumns.VALUATION_REVIEWER]: {
    field: 'valuationReviewer',
    headerName: 'Valuation Reviewer',
    minWidth: 250,
  },
  [TaskColumns.PROPERTY_ADDRESS]: {
    field: 'propertyAddress',
    headerName: 'Property Address',
    minWidth: 300,
  },
  [TaskColumns.PROPERTY_STATE]: {
    field: 'propertyState',
    headerName: 'Property State',
    minWidth: 125,
  },
  [TaskColumns.IV_REASON]: {
    field: 'ivReason',
    headerName: 'Reason',
    minWidth: 200,
  },
  [TaskColumns.TRANSACTION_TYPE]: {
    field: 'transactionType',
    headerName: 'Transaction Type',
    minWidth: 200,
  },
  [TaskColumns.APPRAISAL_RECEIVED_DATE]: {
    field: 'appraisalReceivedDate',
    headerName: 'Appraisal Received Date',
    minWidth: 200,
    cellRenderer: 'dateCellRenderer',
  },
  [TaskColumns.APPRAISAL_PAID_DATE]: {
    field: 'appraisalPaidDate',
    headerName: 'Appraisal Paid Date',
    minWidth: 200,
    cellRenderer: 'dateCellRenderer',
  },
  [TaskColumns.UNDERWRITING_DATE]: {
    field: 'inUnderwritingDate',
    headerName: 'In Underwriting Start Date',
    minWidth: 200,
  },
  [TaskColumns.PROPERTY_CITY]: {
    field: 'propertyCity',
    headerName: 'Property City',
    minWidth: 125,
  },
  [TaskColumns.PROPERTY_COUNTY]: {
    field: 'propertyCounty',
    headerName: 'Property County',
    minWidth: 200,
  },
  [TaskColumns.UNDERWRITER]: {
    field: 'underwriter',
    headerName: 'Underwriter',
    minWidth: 200,
  },
  [TaskColumns.APPRAISER]: {
    field: 'appraiserName',
    headerName: 'Appraiser',
    minWidth: 200
  },
  [TaskColumns.LOAN_SUB_TYPE]: {
    field: 'loanSubtype',
    headerName: 'Loan Subtype',
    minWidth: 250,
  },
  [TaskColumns.LENDER]: {
    field: 'lenderName',
    headerName: 'Lender',
    minWidth: 250,
  },
  [TaskColumns.LOAN_AMOUNT]: {
    field: 'loanAmount',
    headerName: 'Loan Amount',
    minWidth: 150,
    valueFormatter: usdAmount,
  },
  [TaskColumns.ARV]: {
    field: 'afterRepairValue',
    headerName: 'ARV',
    minWidth: 150,
    valueFormatter: usdAmount,
  },

  //CMT
  [TaskColumns.APPRAISAL_REPORT_STATUS]: {
    field: 'appraisalReportStatus',
    headerName: 'Appraisal Present',
    minWidth: 150,
  },
  [TaskColumns.PROJECT_TYPE]: {
    field: 'projectType',
    headerName: 'Special Project',
    minWidth: 150,
  },
  [TaskColumns.CMT_REPORT_VERSION]: {
    field: 'cmtReportVersion',
    headerName: 'Version',
    minWidth: 150,
  },

}